export default "__VITE_ASSET__CvQQzbxY__"